// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"b619991d","339":"894c33be","381":"b8373417","881":"d493e7a8","988":"b8373417"}[chunkId] + ".chunk.css";
};